import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20c1366a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=20c1366a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1366a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c1366a')) {
      api.createRecord('20c1366a', component.options)
    } else {
      api.reload('20c1366a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=20c1366a&scoped=true&", function () {
      api.rerender('20c1366a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/PreProjectLayout/toolbar/index.vue"
export default component.exports